module.exports = __webpack_public_path__ + "static/media/thumbnail.ac9b6d4e.jpg";